/**
 * URL of the super-admin app, which lives on the apex domain and never on a
 * tenant subdomain.
 *
 * This matters for leaving an impersonation session: impersonation writes its
 * session into the *subdomain* origin's localStorage, so the real super-admin
 * session on the apex is untouched and returning there is a plain navigation
 * rather than anything that needs a fresh token.
 */
export const superAdminUrl = (path: string = '/super-admin'): string => {
  const host = window.location.hostname;
  const proto = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : '';

  // Already on the apex.
  if (!host.includes('.') || host === 'localhost') return path;

  if (host.includes('.localhost')) return `${proto}//localhost${port}${path}`;
  if (host.endsWith('.eventik.up.railway.app')) return `${proto}//eventik.up.railway.app${path}`;
  if (host.endsWith('.eventik.cz')) return `${proto}//eventik.cz${path}`;

  // Generic: strip the first label.
  const parts = host.split('.');
  const apex = parts.length > 2 ? parts.slice(1).join('.') : host;
  return `${proto}//${apex}${port}${path}`;
};
